'use strict';

var AdditionalServiceModalCtrl = function (
  additionalService,
  office,
  subscription,
  gettextCatalog,
  OfficeDA,
  Notification,
  modalInstance,
  taxes
) {
  this._modalInstance = modalInstance;
  this._Notification = Notification;
  this._OfficeDA = OfficeDA;
  this.gettextCatalog = gettextCatalog;
  this.office = office;
  this.taxes = taxes;
  this.showPremiumNotification = subscription?.empty === undefined && !['plus', 'enterprise'].includes(subscription?.package);
  this.maxAmounts = [
    {value: 0, label: this.gettextCatalog.getString('unlimited')},
    {value: 1, label: 1},
    {value: 2, label: 2},
    {value: 3, label: 3},
    {value: 4, label: 4},
    {value: 5, label: 5},
    {value: 6, label: 6},
    {value: 7, label: 7},
    {value: 8, label: 8},
    {value: 9, label: 9},
    {value: 10, label: 10},
  ];
  this.additionalService = additionalService || {
    name: '',
    inernal: false,
    extendDuration: true,
    duration: 5,
    price: '0',
    tax: taxes[0].value,
    maxAmount: 0,
    text: ''
  };
  this.formSubmitted = false;
  this.form = null;
  this.selectedService = null;
};

AdditionalServiceModalCtrl.prototype.abort = function () {
  this._modalInstance.close('abort');
};

AdditionalServiceModalCtrl.prototype.delete = function () {
  const index = this.office.additionalServices.findIndex((service) => service._id === this.additionalService._id);

  if (index > -1) {
    this.office.additionalServices.splice(index, 1);

    this.office.serviceGroups.forEach((group) => {
      group.services.forEach((service) => {
        if (service.additionalServices && service.additionalServices[this.additionalService._id]) {
          delete service.additionalServices[this.additionalService._id];
        }
      });
    });

    this._OfficeDA
      .update(this.office)
      .then(() => {
        this._Notification.addSuccessMessage(this.gettextCatalog.getString('Additional Service "{{name}}" deleted', {name: this.additionalService.name}));
        this._modalInstance.close('saved');
      })
      .catch((error) => {
        this._Notification.addErrorMessage(this.gettextCatalog.getString({text: error}));
      });
  } else {
    this._Notification.addErrorMessage(this.gettextCatalog.getString({text: error}));
  }
  console.log(index);
};

AdditionalServiceModalCtrl.prototype.save = function () {
  this.formSubmitted = true;

  if (!this.additionalService?.extendDuration) {
    this.additionalService.duration = 0;
  }

  if (!this.additionalService._id) {
    this.office.additionalServices.push(this.additionalService);
  } else {
    const index = this.office.additionalServices.findIndex((service) => service._id === this.additionalService._id);
    this.office.additionalServices[index] = this.additionalService;
  }

  this._OfficeDA
    .update(this.office)
    .then(() => {
      this._Notification.addSuccessMessage(this.gettextCatalog.getString('Additional Service "{{name}}" saved', {name: this.additionalService.name}));
      this._modalInstance.close('saved');
    })
    .catch((error) => {
      this._Notification.addErrorMessage(this.gettextCatalog.getString({text: error}));
    });
};

module.exports = AdditionalServiceModalCtrl;
